import { Occupation, OccupationResource } from '../Occupations/Occupations';

export interface OccupationOverviewResource {
    meta: {
        totalAmount: number;
    };
    occupations: OccupationResource[];
}

export interface OccupationOverview {
    totalAmount: number;
    occupations: Occupation[];
}

export interface OccupationFilterValues {
    pageNumber: number;
    pageSize: number;
    searchQuery: string;
}

export const defaultOccupationFilterValues = (): OccupationFilterValues => ({
    pageNumber: 1,
    pageSize: 20,
    searchQuery: '',
});

export const defaultOccupationOverview = (): OccupationOverview => ({
    totalAmount: 0,
    occupations: [],
});
